var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 214",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient);}.cls-2{isolation:isolate;}.cls-3{fill:url(#New_Gradient_Swatch_2);}.cls-13,.cls-14,.cls-4,.cls-8{mix-blend-mode:screen;}.cls-4{opacity:0.5;fill:url(#radial-gradient-3);}.cls-5{fill:url(#New_Gradient_Swatch_2-2);}.cls-6{fill:#fff;}.cls-13,.cls-14,.cls-7{fill:#91b706;}.cls-8{opacity:0.3;}.cls-9{fill:#372e70;}.cls-10{fill:url(#linear-gradient);}.cls-11{fill:#1b1532;}.cls-12{mask:url(#mask);}.cls-14{opacity:0.4;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 702.82,
    cy: 713.29,
    r: 42.57,
    gradientTransform: "translate(-409.21 -718.77) rotate(7.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c5c2c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#958f97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#6c656f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#4b424e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#312735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1f1323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#140819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#100415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0d0311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0b030f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2",
    x1: 11.06,
    y1: 106.12,
    x2: 201.61,
    y2: 106.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#372e70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e38"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 106.36,
    cy: 106.12,
    r: 95.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#f2253e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e6233b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#961726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#550d16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#27060a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#0b0203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-2",
    x1: 37.88,
    y1: 106.12,
    x2: 174.83,
    y2: 106.12,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 610.62,
    y1: 633.32,
    x2: 612.63,
    y2: 791.92,
    gradientTransform: "translate(-676.17 -415.28) rotate(-15.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2253e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#f22d3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f3423d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f4643b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f69439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#f7c137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#dabe29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#91b706"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 151.13,
    y: 38.17,
    width: 85.15,
    height: 85.15,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 193.71,
    cy: 80.75,
    r: 42.57,
    transform: "translate(-16.14 83.16) rotate(-23.29)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 106.34,
    cy: 106.12,
    r: 95.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 106.36,
    cy: 106.12,
    r: 95.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 106.36,
    cy: 106.12,
    r: 68.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.9,67c9.47,0,16.93,7.56,16.93,17.36a17,17,0,0,1-17,17.36C67.43,101.75,60,94.38,60,84.39S67.48,67,76.9,67Zm0,32.42c8.08,0,14.4-6.36,14.4-15.06S85,69.33,76.9,69.33,62.51,75.78,62.51,84.39,68.77,99.45,76.9,99.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.43,76.31h2.39V80.9a10.53,10.53,0,0,1,9.23-5.21c7.07,0,12.1,5.4,12.1,13s-4.88,13.1-11.86,13.1a10.79,10.79,0,0,1-9.47-5.36v13.68H99.43ZM111.24,99.5c5.4,0,9.42-4.49,9.42-10.85,0-6.51-4.21-10.72-9.52-10.72-5.78,0-9.42,4.88-9.42,10.72C101.72,95.53,106.07,99.5,111.24,99.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M128.69,71.14h2.39v5.17h5.84v2.15h-5.84v14c0,5.41,1.25,6.79,5,6.79.52,0,1.1,0,1.1,0v2.15s-1.15.09-2.06.09c-3.92,0-6.41-2.43-6.41-7.46V78.46h-3.06V76.31h3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M143,67.75a2,2,0,1,1-2,2A1.94,1.94,0,0,1,143,67.75Zm-1.19,8.56h2.39v24.82H141.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M68.63,111.2H59V109H80.68v2.25H71.07v31.22H68.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M100.33,120.81l-7.65,21.61H90.15L81.3,117.6h2.58l7.56,21.86,7.65-21.86h2.49l7.65,21.86,7.55-21.86h2.59l-8.85,24.82H108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M124.48,109a2,2,0,1,1-2,2A1.94,1.94,0,0,1,124.48,109Zm-1.19,8.56h2.39v24.82h-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M151.84,126.31v16.11h-2.39V126.5c0-4.55-2.87-7.32-6.75-7.32-4.35,0-7.46,3.25-7.46,8.08v15.16h-2.39V117.6h2.39v3.92A8.81,8.81,0,0,1,143,117C148.11,117,151.84,120.52,151.84,126.31Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M10.85,106A95.24,95.24,0,0,1,193.71,68.76a94.67,94.67,0,0,1,7.57,37V106A95.24,95.24,0,0,1,18.41,143.26a94.71,94.71,0,0,1-7.56-37Zm186-.19h-4.45A86.32,86.32,0,0,0,19.75,106v.19A86.32,86.32,0,0,0,192.38,106v-.19Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M131.44,196a93.81,93.81,0,0,1-51-180.54h0a2.39,2.39,0,1,1,1.3,4.6,89,89,0,0,0,48.46,171.34l.19-.06a89,89,0,0,0,61.32-110,2.38,2.38,0,0,1,1.64-3h0a2.39,2.39,0,0,1,2.95,1.64A93.73,93.73,0,0,1,131.64,196Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M228.47,102.16,219,86.1h2.58L229.61,100l8.14-13.88h2.49l-9.54,16.06v14.58h-2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M252.71,93.45c6.7,0,11.64,5.17,11.64,11.91a11.55,11.55,0,0,1-11.68,12c-6.7,0-11.64-5-11.64-12A11.49,11.49,0,0,1,252.71,93.45Zm0,21.8c5.51,0,9.41-4.2,9.41-9.89s-3.86-9.85-9.41-9.85-9.37,4.29-9.37,9.85S247.15,115.25,252.67,115.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M269,108.77V94h2.19V108.6c0,4.15,2.63,6.69,6.17,6.69,4,0,6.83-3,6.83-7.39V94h2.19v22.72h-2.19v-3.59a8.06,8.06,0,0,1-7.09,4.16C272.44,117.31,269,114.07,269,108.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M301.94,95.6c-5.38,0-7,4.42-7,9.15v12h-2.19V94h2.19v4.07a7.24,7.24,0,0,1,7-4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M318.52,86.1h8c5,0,8.45,3.2,8.45,7.84a7.49,7.49,0,0,1-4.12,6.74,7.75,7.75,0,0,1,5.17,7.48,8.54,8.54,0,0,1-8.8,8.58h-8.71Zm8.27,13.66a5.7,5.7,0,0,0,5.87-5.82,5.61,5.61,0,0,0-5.87-5.78h-6v11.6Zm-.26,15c4.16,0,7.18-2.36,7.18-6.56s-3.2-6.39-7.27-6.39h-5.69v13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M341.06,108.77V94h2.19V108.6c0,4.15,2.62,6.69,6.17,6.69,4,0,6.82-3,6.82-7.39V94h2.19v22.72h-2.19v-3.59a8,8,0,0,1-7.09,4.16C344.47,117.31,341.06,114.07,341.06,108.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M365.87,86.19a1.8,1.8,0,1,1-1.8,1.79A1.77,1.77,0,0,1,365.87,86.19ZM364.77,94H367v22.72h-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M373.53,85.1h2.18v31.64h-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M402.32,116.74h-2.19v-4.2a9.64,9.64,0,0,1-8.44,4.77c-6.48,0-11.07-5-11.07-11.86s4.46-12,10.85-12a9.88,9.88,0,0,1,8.66,4.91V85.1h2.19ZM391.51,95.51c-4.94,0-8.62,4.12-8.62,9.94s3.85,9.8,8.71,9.8c5.29,0,8.62-4.47,8.62-9.8C400.22,99.14,396.24,95.51,391.51,95.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M410,86.19a1.8,1.8,0,1,1-1.8,1.79A1.78,1.78,0,0,1,410,86.19ZM408.88,94h2.19v22.72h-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M435,102v14.75h-2.19V102.16c0-4.15-2.63-6.69-6.17-6.69-4,0-6.83,3-6.83,7.39v13.88h-2.19V94h2.19v3.59a8.06,8.06,0,0,1,7.09-4.16C431.6,93.45,435,96.69,435,102Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M443.28,121a14,14,0,0,0,7,2.06c4.9,0,8.89-2.19,8.89-8.05v-2.45a9.67,9.67,0,0,1-8.45,4.77c-6.48,0-11.07-5-11.07-11.86s4.46-12,10.85-12a9.9,9.9,0,0,1,8.67,4.91V94h2.19v19.43c0,8.63-4.51,11.65-11,11.65a16.1,16.1,0,0,1-8-2.37Zm7.31-25.47c-4.95,0-8.63,4.12-8.63,9.94s3.86,9.8,8.71,9.8c5.3,0,8.62-4.47,8.62-9.8C459.29,99.14,455.31,95.51,450.59,95.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M468,85.71a1.87,1.87,0,0,1,1.93,2,7.62,7.62,0,0,1-2.63,5.69l-1.18-1.05a5.9,5.9,0,0,0,1.8-3,1.81,1.81,0,0,1-1.67-1.79A1.78,1.78,0,0,1,468,85.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M475.05,111.35a6,6,0,0,0,5.86,4c2.58,0,4.95-1.62,4.95-4.42,0-6.13-11.73-4.12-11.73-11.6,0-3.63,2.93-5.87,6.78-5.87A6.56,6.56,0,0,1,487.56,98l-1.79.7a4.94,4.94,0,0,0-5-3.28c-2.46,0-4.47,1.4-4.47,3.81,0,5.86,11.73,3.85,11.73,11.64,0,3.81-3.06,6.48-7.18,6.48a7.58,7.58,0,0,1-7.66-5.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M210.7,133.51h5.43c10.63,0,16.5,5.73,16.5,15.32,0,10.32-6.17,15.31-16.5,15.31H210.7Zm6.35,28.58c8.14,0,13.3-4.56,13.3-13.26,0-8.28-5.16-13.26-13.3-13.26h-4.12v26.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M238.84,133.6a1.79,1.79,0,1,1-1.8,1.79A1.76,1.76,0,0,1,238.84,133.6Zm-1.1,7.83h2.19v22.71h-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M248.42,168.39a14,14,0,0,0,7.05,2.05c4.9,0,8.88-2.18,8.88-8.05v-2.45a9.62,9.62,0,0,1-8.44,4.77c-6.48,0-11.08-4.94-11.08-11.86s4.47-12,10.86-12a9.88,9.88,0,0,1,8.66,4.9v-4.33h2.19v19.43c0,8.62-4.51,11.64-11,11.64a16.12,16.12,0,0,1-8-2.36Zm7.31-25.47c-4.94,0-8.62,4.11-8.62,9.93s3.85,9.8,8.71,9.8c5.29,0,8.62-4.46,8.62-9.8C264.44,146.55,260.46,142.92,255.73,142.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M274,133.6a1.79,1.79,0,1,1-1.8,1.79A1.77,1.77,0,0,1,274,133.6Zm-1.1,7.83h2.19v22.71h-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M281.77,136.7H284v4.73h5.34v2H284v12.78c0,4.94,1.14,6.21,4.56,6.21.48,0,1,0,1,0v2s-1.05.08-1.88.08c-3.59,0-5.86-2.23-5.86-6.82V143.4H279v-2h2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M300.89,149.74a9.06,9.06,0,0,1,6.52,2.46v-3.46c0-3.81-2.49-5.87-6.21-5.87a13.48,13.48,0,0,0-7,2.1l-.92-1.7a15.31,15.31,0,0,1,8.06-2.41c5.64,0,8.27,3.28,8.27,8v15.27h-1.8l-.39-2.14a8.23,8.23,0,0,1-6.52,2.71c-5.16,0-8.71-3.32-8.71-7.53S295.86,149.74,300.89,149.74Zm.13,13c3.85,0,6.52-2.37,6.52-5.52s-2.58-5.42-6.56-5.42-6.57,2.36-6.57,5.42S297,162.7,301,162.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M315.72,132.5h2.19v31.64h-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M342.46,135.57h-8.8v-2.06h19.83v2.06h-8.8v28.57h-2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M371.47,144.36l-7,19.78h-2.32l-8.1-22.71h2.37l6.91,20s.05-.13,7-20h2.28c7,19.87,7,20,7,20l6.92-20h2.36l-8.1,22.71h-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M393.57,133.6a1.79,1.79,0,1,1-1.79,1.79A1.76,1.76,0,0,1,393.57,133.6Zm-1.09,7.83h2.18v22.71h-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M418.6,149.39v14.75h-2.19V149.57c0-4.16-2.62-6.7-6.17-6.7-4,0-6.82,3-6.82,7.4v13.87h-2.19V141.43h2.19V145a8,8,0,0,1,7.08-4.16C415.19,140.86,418.6,144.1,418.6,149.39Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 193.71,
    cy: 80.75,
    r: 42.57,
    transform: "translate(-16.14 83.16) rotate(-23.29)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 193.71,
    cy: 80.75,
    r: 42.57,
    transform: "translate(-16.14 83.16) rotate(-23.29)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.470a9ecfc701c7f60358523a68dc1627.svg";
export { ForwardRef as ReactComponent };